<template lang="pug">
  sweet-modal(ref="plan" title="Выбрать тарифный план")
    .plan-modal
      h2 Функция в разработке!
</template>

<script>
export default {
  methods: {
    open() {
      this.$refs.plan.open();
    }
  }
};
</script>
